// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2216":"bf3b217b7955ee0e","2888":"05cea8cff75ba357","5081":"eebba2d6a8b88081","9664":"e064cd4b567998e5"}[chunkId] + ".css";
};